import { rest } from 'msw'
export default [
  /**
   * ポイント付与履歴情報
   */
  rest.post('/api/v2/get_point_history', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: {
          total: {
            type: '✕✕✕✕ポイント',
            point: 2,
          },
          points: [
            {
              id: 3062,
              date: '1596207600',
              source: 'ポイント',
              type: null,
              title: 'Delcy 塩あじえだまめ',
              point: 1,
              status: 1,
              appNo: '007-00359',
            },
            {
              id: 3063,
              date: '1598886000',
              source: 'ポイント',
              type: null,
              title: 'Delcy 塩あじえだまめ',
              point: 1,
              status: 1,
              appNo: '007-00359',
            },
          ],
          count: 2,
          note:
            '※表示されている日付は、お買上げ日です。ポイント特典の付与は毎週土曜日を予定しています。ポイントはお買上げレシートの総ポイントでご確認ください。',
          responseTime: 1604042049,
        },
      })
    )
  }),
]
